/* Planet Action Figures — collection responsive prices V3.
   Prices start 14px below the longest title/content in each row.
   The stock label stays 14px beneath the price, with 14px bottom padding.
   Prices align within each row on desktop and mobile without moving titles. */
(() => {
  if (window.__pafCollectionPriceAlign) return;
  window.__pafCollectionPriceAlign = true;

  let scheduled = false;

  function alignPrices() {
    scheduled = false;
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const cards = Array.from(grid.children)
      .filter(li => li.matches('li.grid__item'))
      .map(li => {
        const card = li.querySelector('.product-card:not(.card--horizontal)');
        const title = card?.querySelector('.card__heading');
        const footer = card?.querySelector('.paf-card-price-footer');
        return footer && title && li.getClientRects().length
          ? {li, title, footer} : null;
      }).filter(Boolean);

    /* Clear previous row offsets before measuring, including resizing. */
    for (const item of cards) {
      item.title.style.marginTop = '';
      item.footer.style.removeProperty('--paf-price-row-offset');
    }

    const rows = new Map();
    for (const item of cards) {
      const top = Math.round(item.li.getBoundingClientRect().top / 3) * 3;
      if (!rows.has(top)) rows.set(top, []);
      rows.get(top).push(item);
    }

    for (const row of rows.values()) {
      if (row.length < 2) continue;
      const measurements = row.map(item => ({
        item,
        priceTop: item.footer.getBoundingClientRect().top
      }));
      const targetTop = Math.max(...measurements.map(m => m.priceTop));

      /* Extend ONLY the title-to-price gap of shorter cards.
         The longest title keeps the minimum 14px gap. */
      for (const {item, priceTop} of measurements) {
        const extra = Math.max(0, targetTop - priceTop);
        if (extra > .5) {
          item.footer.style.setProperty('--paf-price-row-offset', extra.toFixed(1) + 'px');
        }
      }
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(alignPrices);
  }

  function start() {
    schedule();
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('load', schedule, {once: true});
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts?.ready) document.fonts.ready.then(schedule);
    const root = document.querySelector('main') || document.body;
    new MutationObserver(schedule).observe(root, {childList:true, subtree:true});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once:true});
  } else start();
})();